<template>
  <v-container grid-list-md pt-0 class='subscription'>
    <v-layout row wrap>
      <transition name='fade'>
        <v-flex xs12 v-if='loaded == true'>
          <subscription-br v-if="this.profile.region === 'BR'"></subscription-br>
          <subscription-ec v-else-if="this.profile.region === 'EC'"></subscription-ec>
          <subscription-unavailable v-else></subscription-unavailable>
        </v-flex>
      </transition>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios';
import bus from '@/utils/bus';
import loading from '@/components/Loading';
import subscriptionBR from '@/components/subscription/br';
import subscriptionEC from '@/components/subscription/ec';
import subscriptionUnavailable from '@/components/subscription/unavailable';

export default {
  name: 'subscription',
  components: {
    loading,
    'subscription-br': subscriptionBR,
    'subscription-ec': subscriptionEC,
    'subscription-unavailable': subscriptionUnavailable
  },
  data() {
    return {
      loaded: false,
      loading: false,
      profile: {}
    };
  },
  mounted() {
    this.getProfile();
    // bus.$emit('loading', false);
  },
  methods: {
    getProfile() {
      this.loading = true;
      bus.$emit('loading', true);

      axios
        .get('/profiles/me')
        .then(response => {
          this.$store.commit(
            'setSubscription',
            response.headers['active-subscription']
          );
          this.$store.commit('setProfile', response.data);
          this.profile = response.data;
          this.loaded = true;
          this.loading = false;
          bus.$emit('loading', false);
        })
        .catch(e => {
          // console.error(e)
          this.loaded = true;
          this.loading = false;
          bus.$emit('loading', false);
        });
    }
  }
};
</script>

<style lang='scss'>
@import '../assets/css/_variables';

.subscription {
  @media only screen and (max-width: 480px) {
  }
}
</style>
